import PropTypes from 'prop-types'
import OtpInput from '@/components/OtpInput'
import Button from '@/components/Button'

const OtpStep = ({
  email,
  otp,
  onChange,
  onSubmit,
  onResend,
  resendLoading,
  verifyLoading,
  cooldown,
  blocked,
}) => {
  const anyLoading = resendLoading || verifyLoading

  return (
    <>
      <div className="w-full flex flex-col gap-4">
        <h1 className="m-0 font-avenir-heavy tracking-normal text-grey-10 text-[2.5rem] leading-12 font-heavy max-tablet-p:text-[2rem] max-tablet-p:leading-8 text-left max-tablet-p:text-center">
          Enter Verification Code (OTP)
        </h1>
        <p className="font-avenir-medium type-body-2 tracking-normal text-grey-50 m-0 text-left max-tablet-p:text-center">
          A verification code has been sent to {email}.
        </p>
      </div>

      <form className="flex flex-col gap-10" onSubmit={onSubmit} noValidate>
        <div className="flex flex-col relative">
          <OtpInput digits={otp} onChange={onChange} disabled={anyLoading} />
        </div>

        <div className="flex items-center justify-between gap-4">
          <Button
            type="button"
            btnText
            onClick={onResend}
            disabled={cooldown > 0 || anyLoading}
            loading={resendLoading}
            addClass="w-49"
          >
            {!blocked && cooldown > 0 ? `Resend code (${cooldown}s)` : 'Resend code'}
          </Button>

          <Button
            type="submit"
            round
            loading={verifyLoading}
            disabled={otp.length !== 6 || anyLoading}
            addClass="w-49"
          >
            Verify OTP
          </Button>
        </div>
      </form>
    </>
  )
}

OtpStep.propTypes = {
  email: PropTypes.string.isRequired,
  otp: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
  resendLoading: PropTypes.bool,
  verifyLoading: PropTypes.bool,
  cooldown: PropTypes.number.isRequired,
  blocked: PropTypes.bool,
}

export default OtpStep
